module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xpelv5-af4549a35e548e3f1136c259df9988ca.jpg";